import React from 'react';
import {
    IonGrid,
    IonRow,
    IonCol,
    IonSpinner,
    IonText,
} from '@ionic/react';
import { Product } from '../../../models/shop.model';
import ProductCard from '../../shop/components/ProductCard';
import CartButton from '../../shop/components/CartButton';

export interface StorefrontListingProps {
    products: Product[];
    isFetching: boolean;
    hasFetched: boolean;
    cartCount: number;
    currencyPrefix?: string;
    onAddToCart: (product: Product, learnerId: number | null) => void;
}

export const StorefrontListingComponent: React.FC<StorefrontListingProps> = ({
    products,
    isFetching,
    hasFetched,
    cartCount,
    currencyPrefix,
    onAddToCart,
}) => {
    const showLoading = isFetching && !hasFetched;
    const showEmpty = !isFetching && hasFetched && products.length === 0;

    return (
        <>
            {/* Cart button — floats in top-right via StorefrontPage header slot, or inline */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 16px' }}>
                <CartButton count={cartCount} routerLink="/shop/cart" />
            </div>

            {showLoading && (
                <div
                    data-testid="storefront-loading"
                    style={{ display: 'flex', justifyContent: 'center', padding: '48px' }}
                >
                    <IonSpinner name="crescent" />
                </div>
            )}

            {showEmpty && (
                <div
                    data-testid="storefront-empty"
                    style={{ textAlign: 'center', padding: '48px 24px' }}
                >
                    <IonText color="medium">
                        <p>No products available at this time.</p>
                    </IonText>
                </div>
            )}

            {!showLoading && products.length > 0 && (
                <IonGrid>
                    <IonRow>
                        {products.map((product) => (
                            <IonCol key={product.productKey} size="12" sizeMd="6">
                                <ProductCard
                                    customer={null}
                                    product={product}
                                    currencyPrefix={currencyPrefix}
                                    onAddToCart={onAddToCart}
                                />
                            </IonCol>
                        ))}
                    </IonRow>
                </IonGrid>
            )}
        </>
    );
};
